<template>
  <div>
    <p class="font-medium capitalize">{{ title.replaceAll('_', ' ') }}</p>

    <TableWrapper>
      <THead>
        <TRHead>
          <TH>
            <span>Roles</span>
          </TH>
          <TH v-for="(head, ind) in modules.table_headings" :key="ind">
            <span class="flex items-center">
              {{ head && head.heading.replaceAll('_', ' ') }}
              <TooltipIcon
                v-if="head.more_info"
                :term="head.more_info"
                :dynamic-message="true"
                :height="20"
                :width="20"
                custom-tooltip="-ml-52"
                color="primary-purple-700"
              />
            </span>
          </TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(subModule, index) in modules.table_rows" :key="index">
          <TD>
            <span>{{ index.replaceAll('_', ' ') }}</span>
          </TD>
          <TD v-for="(value, idx) in subModule" :key="`sub-module${idx}`">
            <div v-if="!value.not_applicable" class="flex">
              <UiCheckBox
                :key="`forceRenderCheckbox${forceRender}-${idx}`"
                :model-value="value.is_permissible"
                :halt-update="value.is_locked"
                @update:modelValue="updateSetting(value, 'checkbox')"
              />
              <span
                class="block box-border h-6 border_width border-primary-grey mx-2 visible"
              ></span>
              <UiLockButton
                :model-value="value.is_locked"
                :deactivate="value.is_locked_at_upper_level"
                v-bind="value"
                :class="[{ 'pointer-events-none': currentSectionScope }]"
                @update:modelValue="updateSetting(value, 'lock')"
              />
            </div>
            <div v-else class="flex">
              <span class="text-4xl flex items-center text-gray-600 h-6">--</span>
              <span
                class="block box-border h-6 border_width border-primary-grey ltr:mx-2 rtl:mx-2 visible"
              ></span>
              <span class="text-4xl flex items-center text-gray-600 h-6">--</span>
            </div>
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
/* COMPONENTS */
import UiLockButton from '@src/components/UiElements/UiLockAnimation.vue'
import UiCheckBox from '@src/components/UiElements/UiCheckbox.vue'
import TooltipIcon from '@src/router/views/landingPage/TooltipIcon.vue'
import scrollMixin from '@src/mixins/scroll-mixin'

/* UTILS */
import { objectDeepCopy, removeEmptyKeysFromObject } from '@utils/generalUtil'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'

export default {
  components: {
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
    UiCheckBox,
    UiLockButton,
    TooltipIcon,
  },

  mixins: [scrollMixin],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    title: {
      type: String,
      default: 'Role',
    },
    modulesArray: {
      type: [Array, Object],
      default: () => ({}),
    },
  },
  emits: ['updateSettings'],
  data() {
    return {
      isLocked: '',
      modules: objectDeepCopy(this.modulesArray),
      settings: 'settings',
      forceRender: 0,
    }
  },
  computed: {
    ...mapState('layout', ['currentSectionScope']),
  },
  methods: {
    async updateSetting(value, type) {
      let res, err
      if (type === 'lock' && this.currentSectionScope) return
      removeEmptyKeysFromObject(value)
      this.updateObject(value, type)
      delete value.id
      ;[res, err] = await this.updateFeaturePermissionsSettings(value)
      if (res) {
        this.$emit('updateSettings')
      } else {
        this.updateObject(value, type)
      }
      value.id = Math.random() * 100000
      this.forceRender++
    },
    updateObject(object, type) {
      switch (type) {
        case 'checkbox': {
          object.is_permissible = !object.is_permissible
          break
        }
        case 'lock': {
          object.is_locked = !object.is_locked
          break
        }
      }
    },
    /* ACTIONS */
    ...mapActions('settings', ['updateFeaturePermissionsSettings']),
  },
}
</script>

<style lang="scss" scoped>
.border_width {
  border-width: 0.5px;
}
</style>
